package net.frozenbit.games.soundgame.ui.utils

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.AnimationVector1D
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import kotlin.time.Clock
import kotlin.time.Instant

@Composable
internal fun animateTimeProgress(
    startTime: Instant?,
    endTime: Instant?
): Animatable<Float, AnimationVector1D> {
    val progress = remember { Animatable(0f) }
    LaunchedEffect(startTime, endTime) {
        if (startTime == null || endTime == null) {
            progress.snapTo(0f)
            return@LaunchedEffect
        }

        val now = Clock.System.now()
        val totalDuration = endTime - startTime
        val remainingDuration = endTime - now
        val currentProgress = (1f - (remainingDuration / totalDuration).toFloat())
            .coerceIn(0f, 1f)
        val remainingMillis = remainingDuration.inWholeMilliseconds
            .coerceIn(0, Int.MAX_VALUE.toLong())
            .toInt()

        progress.snapTo(currentProgress)
        progress.animateTo(
            targetValue = 1f,
            animationSpec = tween(
                durationMillis = remainingMillis,
                easing = LinearEasing,
            ),
        )
    }
    return progress
}